import {debounce} from "lodash-es";

const Autocomplete = (function(window, $) {

    function Autocomplete(el) {
        this.$searchForm = $(el);
        this.$searchInput = this.$searchForm.find('input.search-form-input');
        this.$autoCompleteContainer = this.$searchForm.find('.autocomplete-container');
        this.$autoCompleteList = this.$searchForm.find('.autocomplete-list');

        // These elements are defined outside the element
        this.$overlay = $('.overlay-header-search');
        this.$clear = $('.search-clear-trigger');

        if (this.$searchInput.length && this.$searchInput.val().length >= 1) {
            this.$clear.removeClass('is-hidden');
        }

        this.addEvents();
    }

    Autocomplete.prototype.addEvents = function() {
        this.$searchInput.on('keyup input', debounce(this.inputHandler, 200).bind(this));
        this.$searchInput.on('focus', this.show.bind(this));
        this.$searchInput.on('blur', this.blur.bind(this));
        this.$clear.on('click', this.clearClickHandler.bind(this));
        this.$overlay.on('click', this.hide.bind(this));
        this.$autoCompleteList.on('click', 'a', this.resultClickHandler.bind(this));
    };

    Autocomplete.prototype.blur = function() {
        // Hiding should be on a interval, otherwise click handlers will never execute (eg. overlay click or autocomplete result click)
        setTimeout(this.hide.bind(this), 200);
    };

    /**
     * Show all autocomplete related elements
     */
    Autocomplete.prototype.show = function() {
        // Show previous search
        if (this.$searchInput.val().length > 2 && this.hasResults) {
            this.$autoCompleteContainer.show();
            this.$autoCompleteContainer.addClass('is-visible'); // needed for scroll event in header.js to check if searchresults are visible or not
            this.$clear.addClass('is-visible');
            this.$overlay.show();
        } else {
            this.$autoCompleteContainer.removeClass('is-visible');
            this.hide();
        }        
    };

    /**
     * Hide all autocomplete related elements
     */
    Autocomplete.prototype.hide = function() {
        if(! this.$autoCompleteContainer.hasClass('is-visible')) {
            this.$autoCompleteContainer.hide();
        }
        this.$autoCompleteContainer.removeClass('is-visible');
        this.$overlay.hide();
    };

    /**
     * Change interface when a result is clicked
     */
    Autocomplete.prototype.resultClickHandler = function(e) {
        let text = $(e.target).text().trim().toLowerCase();
        let target = $(e.target);

        if (target.is('a') || target.is('span.autocomplete-highlight')) { // check if target is an actual link - otherwise the whole list whill be put as val
            this.$searchInput.val(text);
            this.$autoCompleteContainer.hide();
        }
    };

    /**
     * Clear input
     */
    Autocomplete.prototype.clearClickHandler = function(e) {
        this.hide();
        this.$searchInput.val('');
        this.$clear.addClass('is-hidden');
        this.$searchInput.focus();
    };

    /**
     * Handler is executed while user is typing
     */
    Autocomplete.prototype.inputHandler = function() {
        let searchText = this.$searchInput.val();
        let postType = this.$searchForm.find('[name="post_type"]').val();

       if (searchText.length < 1) {
            this.$clear.addClass('is-hidden');
        } else if (searchText.length >= 1) {
            this.$clear.removeClass('is-hidden');
        }

        if (searchText.length < 3) {
            this.$autoCompleteContainer.removeClass('is-visible');
            this.$autoCompleteContainer.hide();
            return;
        }

        // Dynamic width
        this.$autoCompleteContainer.width(this.$searchInput.outerWidth());

        this.getResults(searchText, postType);
    };

    /**
     * Fetch AJAX results
     * @param keyword
     * @param postType
     */
    Autocomplete.prototype.getResults = function(keyword, postType) {

        // Prevent double requests
        if (this.xhr) {
            this.xhr.abort();
        }

        this.xhr = $.ajax(window.ajaxURL, {
            type: 'POST',
            data: {
                'text': keyword,
                'post_type': postType,
                'action': 'autocomplete'
            },
            dataType: 'json',
        }).done(function (data) {
            this.$autoCompleteList.html(data.html);
            this.hasResults = data.hasResults;
            this.show();
        }.bind(this));

    };

    return Autocomplete;

}(window, jQuery));

export {Autocomplete};
